function parseHostList(s) {
  if (!s || typeof s !== 'string') return []
  return s.split(',').map((x) => x.trim().toLowerCase()).filter(Boolean)
}

function isLocalLoopback(hostname) {
  const h = (hostname || '').toLowerCase()
  return h === 'localhost' || h === '127.0.0.1' || h === '[::1]'
}

function baseDomains() {
  const raw = import.meta.env.VITE_BASE_DOMAINS
  if (raw && String(raw).trim()) return parseHostList(String(raw))
  return ['paysafego.com', 'paysafego.net', 'appstaging.biz', 'localhost']
}

/**
 * True when the SPA is served from the platform management host (admin.*).
 * Align with backend BASE_DOMAINS / PLATFORM_ADMIN_HOSTS — set VITE_PLATFORM_ADMIN_HOSTS / VITE_BASE_DOMAINS when needed.
 */
export function isPlatformAdminHostname(hostname) {
  if (typeof window === 'undefined') return false
  const h = (hostname || window.location.hostname || '').split(':')[0].toLowerCase()
  if (!h) return false
  if (parseHostList(import.meta.env.VITE_PLATFORM_ADMIN_HOSTS || '').includes(h)) return true
  const devPort = import.meta.env.VITE_PLATFORM_ADMIN_DEV_PORT
  if (devPort && isLocalLoopback(h)) {
    const p = window.location.port
    const fallback = window.location.protocol === 'https:' ? '443' : '80'
    const effective = p || fallback
    if (String(devPort) === effective) return true
  }
  for (const base of baseDomains()) {
    if (h === `admin.${base}`) return true
  }
  return false
}

/** Allowed on the platform host (slim shell). Venue admin belongs on the organization site only. */
const PLATFORM_PATH_PREFIXES = ['/admin/platform-config', '/admin/tenants', '/admin/billable-usage', '/admin/usage', '/admin/profile']

/** Platform-only UI/API surfaces — hidden and blocked on tenant subdomains even for super_admin. */
const PLATFORM_CONSOLE_ONLY_PREFIXES = ['/admin/platform-config', '/admin/tenants']

/** Routes allowed when signed in on the platform console host (all other app paths redirect). */
export function isPlatformConsolePath(pathname) {
  if (!pathname || typeof pathname !== 'string') return false
  const p = pathname.split('?')[0]
  return PLATFORM_PATH_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`))
}

export function isTenantSiteBlockedPlatformRoute(pathname) {
  if (!pathname || typeof pathname !== 'string') return false
  const p = pathname.split('?')[0]
  return PLATFORM_CONSOLE_ONLY_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`))
}
